import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Box } from '@mui/material';
import Zoom from '@mui/material/Zoom';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import React from 'react';
import { iconStyle, scrollTopButtonStyle } from './styled';

// to deal with over-scroll bouncing issue in Safari
// it requires two triggers to determine when to show/hide the scroll-to-top button
const ScrollToTopButton: React.FC = () => {
  // set a top trigger at 100px with hysteresis
  // meaning the trigger value will be re-computed when scroll direction changes (scrolling up = false)
  // this is used to hide the scroll-to-top button when the user scrolls up
  const topTrigger = useScrollTrigger({
    target: window,
    threshold: 100,
  });

  // set a bottom trigger at full height - viewport height - 100px buffer without hysteresis
  // meaning the trigger value will not be re-computed when scroll direction changes
  const bottomTrigger = useScrollTrigger({
    disableHysteresis: true,
    target: window,
    threshold: document.body.scrollHeight - window.innerHeight - 100,
  });

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  /**
   * - When the scroller is positioned in between top trigger and bottom trigger,
   * the top trigger determines shouldDisplay as the bottom trigger will always be false
   * - When the scroller passes the bottom trigger threshold, the bottom trigger determines shouldDisplay
   * as the bottom trigger will always be true
   * - When scrolling is unavailable, hide the button
   */
  const shouldDisplay = topTrigger || bottomTrigger && !(document.body.scrollHeight === window.innerHeight);
  return (
    <Zoom in={shouldDisplay}>
      <Box role="presentation" onClick={handleClick} sx={scrollTopButtonStyle} data-automation="scroll-to-top-btn">
        <KeyboardArrowUpIcon sx={iconStyle} />
      </Box>
    </Zoom>
  );
};

export default ScrollToTopButton;
